var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-toolbar-items',{staticClass:"hidden-md-and-down"},_vm._l((_vm.menuItems),function(item){return (!item.external)?_c('v-btn',{key:item.title,staticClass:"font-weight-bold",class:{
    'text-body-1': _vm.$vuetify.breakpoint.mdAndDown,
    'text-body-1': _vm.$vuetify.breakpoint.lgAndUp,
  },attrs:{"text":"","to":item.path}},[_vm._v(" "+_vm._s(item.title)+" ")]):_c('v-btn',{staticClass:"font-weight-bold",class:{
    'text-body-1': _vm.$vuetify.breakpoint.mdAndDown,
    'text-body-1': _vm.$vuetify.breakpoint.lgAndUp,
  },attrs:{"text":"","href":item.path,"target":"_blank","rel":"noopener noreferrer"}},[_vm._v(" "+_vm._s(item.title)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }